module.exports = new __parcel__URL__("growth-sprout.0c2e3e30.svg").toString();